const StakeWorld = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path
      style={{
        fill: "#fff",
      }}
      d="M0 0h512v512H0z"
    />
    <path
      fill="#184891"
      d="M273.84 462.49c-15.14 0-30.15 0-45.7-.41a7.68 7.68 0 0 0-1.93-1.65c-27.81-4-54-12.12-77.78-28.09-17.76-11.7-34.83-23.95-48.87-40-4-4.41-7.16-9.92-10.18-15a50.74 50.74 0 0 1 7.57-1c4.54-.42 9.36-.83 11.15-6.06 2.2-5.51 5.78-7.57 11.84-6.61 3.71 2.07 7 4.82 10.73 5.92a33 33 0 0 0 13.22 1c1.38-.13 1.93-4.81 3.58-6.74a31.6 31.6 0 0 1 7.57-7.85c2.89-1.79 6.47-2.61 9.77-3.3a25.25 25.25 0 0 1 9.09 0 77.12 77.12 0 0 1 12.53 4c.41 1.1.55 2.48 1.1 2.75 8.53 3.31 10.6 11.29 13.63 18.73 1 2.2 2.06 5.36 3.85 6.33 4.41 2.34 6.06 5.92 7 10.19 1.24 4.4 2.89 8.67 4 12.94a10.84 10.84 0 0 1-.41 6.33c-4 8.4-8.4 16.66-12.8 25.33 3.44 1.51 7 2.89 10.46 4.68 3.3 1.51 7.43 2.61 9.91 5.23a14.09 14.09 0 0 0 9.78 3.72c5.64.27 11.56.27 17.2 1.51 8 1.65 15-2.06 16.25-10.05.55-4.4.55-8.95 1.1-13.35.14-1.24.27-2.89 1.24-3.58a116.25 116.25 0 0 1 12.8-10.6c3.17-1.93 6.2-3.44 7-7.57.14-1.38 2.34-2.62 3.86-3.17 5.92-1.65 11.7-2.89 17.75-4.4 1.24-.42 2.9-.83 3.58-1.79 5.79-8.13 6.47-17.49 4.41-26.85-.83-2.89-3.3-5.78-5.64-8.12-3.17-3.3-7.58-5.78-10.6-9.36-9.5-11.7-9.37-11.84-24-9.5a1.32 1.32 0 0 0-.41.14c-4.41.41-7-1.38-7.85-5.78-1.24-6.89-1.93-14-3.3-20.93-.41-2.06-2.07-3.71-3-6-2.89-15 2.75-24.1 17.48-27.4a3.15 3.15 0 0 0 1.38-.69c2.89-1.79 6.33-3.3 8.53-5.78 3.86-4 7-8.67 10.47-13.22 6.47-8.53 14.59-14 25.6-15.14 1.38-.14 3.31-2.48 3.58-4 1.1-5.64 1.52-11.29 2.2-17.35a54.71 54.71 0 0 1 4.55-6.88c4.95 3.17 9.91 5.92 14.31 9.09 2.76 1.79 4.82 1.51 6.89-.83 2.75-3.17 5.37-6.33 8.26-9.22 6.05-6.33 6.19-6.2 13.62-1.65a54.28 54.28 0 0 1 5.1 3c.69 6.47-3.17 12.81.55 18.86 1.93 3.17 1.93 6.34 1 9.78-.82 2.48-1.79 5.92-.82 7.43a44.06 44.06 0 0 1 9.5 24.92c3.3-.55 5.91-.69 8.67-1.52 5.5-1.65 11-3.71 16.65-5.64 4.27-1.51 7.16.28 8.13 4.13a156.73 156.73 0 0 0 5.37 16.79c.68 1.52 2.89 2.62 4.68 4a1.78 1.78 0 0 0 1.37.27 5.24 5.24 0 0 1 .59-.48 2 2 0 0 1 .69.41c3.72 3.86 7.16 7.44 10.88 11.29a87.59 87.59 0 0 1-2.34 10.74 189.45 189.45 0 0 1-27.54 52.45 213.59 213.59 0 0 1-42.95 44.05c-19.41 14.73-40.74 26-64.28 32.76-12.53 3.44-25.06 7.57-38.27 6.75-1.11-.14-2.21 1.24-3.31 2.06Z"
    />
    <path
      d="M49.18 229.71c4.4-2.07.82-5.65 2.48-8.4 7.29 4.27 17.89 5 17.75 16.24h25.88a37.6 37.6 0 0 1 2.9 2.62c-1.38 10.05-3.31 19-14.46 21.61-5.37 1.38-6.47 5-4.27 9.64 2.48 4.82.55 8.26-3.44 11-3.85 2.48-7.43 5.09-11.56 7.71-4.68-1.51-8.81-2.89-13.08-4.27a8.83 8.83 0 0 0-1.79-3.16c-.41-17.49-.41-35.11-.41-53Z"
      style={{
        fill: "#1163ae",
      }}
    />
    <path
      fill="#1773ba"
      d="M261.73 49.51c1.24 4.4 1.93 8.81 3 13.08.82 3.16 0 5.36-3 7.57-5.37.68-10.33 1.1-15.15 1.37-6.05-3.71-7.84-8.81-5.64-15.41.55-1.79.28-3.86.28-6.2 6.74-.41 13.35-.41 20.51-.41Z"
    />
    <path
      d="M460.79 232.32c0 14.73 0 29.46-.42 44.6a15 15 0 0 1-5.5-1.79c-1.38-2.2-2.89-4-3.72-6.19a14.48 14.48 0 0 1-.83-5.92c.42-3.44 1.66-6.74 1.93-10.19s-.69-7.15-1.1-11.15c.41-8.26 1.38-9.36 9.64-9.36Z"
      style={{
        fill: "#174994",
      }}
    />
    <path
      fill="#273779"
      d="M455 275.41c1.66.55 3.31 1.38 5.37 2.07a17.14 17.14 0 0 1 .42 4.81c-1.1 3.44-2.34 6.34-3 9.36-1.79 7-3.17 14.05-5 21.48a105 105 0 0 1-11.15-11c4.41-9.36 9-18.17 13.35-26.71Z"
    />
    <path
      fill="#1e4485"
      d="M460.79 231.91c-8.26.41-9.23 1.51-9.91 9.64-4.55-3.17-8.68-6.47-12.95-9.92a12.24 12.24 0 0 1-2.34-15.69c.42 1.24.42 2.75 1.11 3 7.43 2.06 13.07 9.5 21.75 8.12a5 5 0 0 0 1.92 1.1 9.75 9.75 0 0 1 .42 3.72Z"
    />
    <path
      d="M263.38 313.4a129.47 129.47 0 0 1-15.83 3.72 9.9 9.9 0 0 1-3.44-.41c-6.61-1.79-13.22-3.72-20.24-6.06 1-9.63 2.34-18.72 3.72-27.67 8.53 1.38 13.35-2.48 14.87-10.74a8.65 8.65 0 0 1 1.37-2.89c3.17-2.2 6.75-5.78 8.54-5.09 8 3 15.55-.28 23.4.55 3.3.41 5.78-1.1 6.88-4.82 2.07-6.88 4.68-13.63 7.3-20.37 1.93-.28 3.44-.69 5.37-.83 3 0 6.19.28 8.81-.41 9.63-2.48 19-5.51 28.49-8.12-.68 5.64-1.1 11.29-2.2 16.93-.27 1.51-2.2 3.85-3.58 4-11 1.1-19.13 6.61-25.6 15.14-3.44 4.55-6.61 9.23-10.47 13.22-2.2 2.48-5.64 4-8.53 5.78a3.26 3.26 0 0 1-1.38.69c-14.73 3.3-20.37 12.39-17.48 27.39Z"
      style={{
        fill: "#124b96",
      }}
    />
    <path
      fill="#0f4e99"
      d="M89.38 377.28a138.87 138.87 0 0 1-10.6-13.77c-.83-1.24-.28-3.58 0-5.78 8.94-5.09 17.75-9.36 22.16-19.27 7.16-3.58 13.9-7 20.92-10.74a6.88 6.88 0 0 0 2.07-2.61c1.51-5.65 5.37-6.34 10.19-5.1a7.63 7.63 0 0 0 2.47.42c8.26-.28 16.66-.55 24.92-.42.83 11.29-6.06 15-15 15.28a77.73 77.73 0 0 0-9.77.14 4.91 4.91 0 0 0-3 1.79c1.65 4.41-2.2 6.33-3.85 9.09-3.31 5.92-6.89 11.56-10.33 17.34-5.64-1-9.22 1.1-11.42 6.61-1.79 5.23-6.61 5.64-11.15 6.06a50.74 50.74 0 0 0-7.57 1Z"
    />
    <path
      fill="#124b97"
      d="M119.94 363.65c3-5.78 6.6-11.42 9.91-17.34 1.65-2.76 5.5-4.68 3.85-9.09a4.91 4.91 0 0 1 3-1.79 77.73 77.73 0 0 1 9.77-.14c8.95-.27 15.84-4 15.29-15.55a52.57 52.57 0 0 1 5.36-7.57c7.58 3.58 14.73 7.15 21.89 10.6-5.37 10.46-4.82 21.61-2.61 33.17-4.27-1-8.4-2.48-12.53-3.3a25.25 25.25 0 0 0-9.09 0c-3.3.69-6.88 1.51-9.77 3.3a31.6 31.6 0 0 0-7.57 7.85c-1.65 1.93-2.2 6.61-3.58 6.74a33 33 0 0 1-13.22-1c-3.71-1.1-7-3.85-10.73-5.92Z"
    />
    <path
      fill="#124b97"
      d="M384.11 192.4c2.75 1.93 6.88 3.44 8 6.2 1.93 5.23 2.34 11.15 2.89 16.93.14 1-2.06 2.34-3.44 3.3a58 58 0 0 1-6.05 3.86 26.58 26.58 0 0 1-5.24-2.34c-7.43-4.55-7.57-4.68-13.62 1.65-2.89 2.89-5.51 6.05-8.26 9.22-2.07 2.34-4.13 2.62-6.89.83-4.4-3.17-9.36-5.92-14.31-9.36a2.24 2.24 0 0 1-.28-1.38c.41-2.48.83-4.41 1.1-6.61.69-4 2.48-5.78 7-5.64a64.08 64.08 0 0 0 14.46-1.1c4.54-.83 9.91.13 11.42-7.3 1.93-10.32 2.21-8 11.15-8.26Z"
    />
    <path
      fill="#0f4e99"
      d="M336.89 221.86v.69c-1.38 2.48-2.75 4.68-4.27 7.29-9.5 3-18.86 6.06-28.49 8.54-2.62.69-5.78.41-8.81.14-.55-.42-.55-1-.14-1.1a33.6 33.6 0 0 0 1.93-5c1.1-2.75 1.65-7.16 3.44-7.71 6.74-2.34 13.35-6.06 21.06-4.4 4.96 1 10.19 1 15.28 1.55Z"
    />
    <path
      fill="#273779"
      d="M439 302.12c.09-.19.46-.1 1.1.27-.1.19-.51.09-1.1-.27Z"
    />
    <path
      fill="#105ca8"
      d="M383 133.62a10.09 10.09 0 0 1-1.38 2.75 69.21 69.21 0 0 1-12.11-4.4c-3.72-1.66-5.65-1.24-7.85 2.75-1.79 3.17-5 7.16-8.12 7.71-8.67 1.51-12.25 5.92-12.53 14.18a6.58 6.58 0 0 1-.14 1.65c-.55 2.75-1.79 4.13-5.09 3.17-4.27-1.24-8.54-1.79-12.67-2.89-7.15-1.66-8-1.66-10.18 5.5-1.38 4.68-4.54 6.2-8.81 6.2-3.72.13-7.44 0-11 0-3.85 0-6.05 1.37-5.64 5.64a15.66 15.66 0 0 1-.14 6.2c-.41 1.79-1.37 4.26-2.75 4.68-8 3.58-13.35 8.53-13.63 17.75a15.4 15.4 0 0 1-.27 1.79c-3.58 4.55-5.92 10.6-12.53 10a32.89 32.89 0 0 0-15.57 2.7 9.76 9.76 0 0 1-4 .69c-5.64-.28-11-.83-16.66-1.1-1.92-7.44-3.71-15-5.5-22.44-.14-1 1-2.21 1.79-2.89a6.76 6.76 0 0 1 2.47-1c13.08-1.92 19.69-10 22.72-22.85a33.58 33.58 0 0 1 8.67 3.3c6.06 3.72 13.49.56 14.32-6.74.55-5 .82-9.91 1.1-14.87 5.23-1.24 10.19-2.61 15.28-3.85 1.79-.55 3.58-1.79 6.19-2.89 5.37-.28 10-.28 14.73-.28 5.24 0 11.57-5.78 12.12-11s.69-10.6 1.1-16c.14-4.54 1.51-5.51 5.37-3.44 5.09 2.89 9.64 6.19 14.87 8.67 2.06 1.1 5.92 1.51 7.43.41 4.54-3.16 9.09-4.13 14.73-4 1.24.55 2.75.55 3 1.24 1.93 5.09 6.47 6.33 10.74 8.12a77 77 0 0 1 9.91 5.51Z"
    />
    <path
      d="M57.44 195.57c.69-3 1-6.47 2.34-9.23 4.68-10.6 9.77-20.92 14.73-31.25 2.61-5.23 4.54-10.87 7.57-15.83 2.48-4 6.19-7.16 9.36-10.73 6.19-7.16 11.84-14.73 18.45-21.48 5.78-5.64 12.39-10.46 18.86-15.42A192.39 192.39 0 0 1 175 64c13.49-5.64 27.26-10.46 42-12 .14 0 .27.13.69.68a47.81 47.81 0 0 1 .55 7.44c0 6-1.24 7.16-7.44 7.16-5.5 0-11.15-.55-16.79 3.16-1.93 0-3.17.41-3.86-.14-8.12-5.23-12.94 0-17.75 5.37a98.45 98.45 0 0 1-7.71 7.44c-.69 1.65-1.93 3.3-2.07 5.09-.69 7.16-4 13.08-9.22 18.45-3.72-1.66-7.71-2.76-11.15-5.1-7.71-5.23-13.36-.55-19.69 3-5.92 3.31-5.64 9.36-7.29 14.46a11.88 11.88 0 0 1-3.17 4.54 35.68 35.68 0 0 1-7.57 4.54c-4.68 2.48-7.57 5.23-7.57 11.43.13 3.58-3 7.57-5.65 10.6-3.3 4-3.3 7.29 0 11.15 1.52 1.79 2.62 3.72 4.13 5.78-3.58 5.92-6.88 12.25-11 18-1.65 2.07-4.82 3-7.3 4.41-1.92 1.24-4 2.06-6.47 3.58-4.81 1.1-9.08 1.79-13.21 2.48Z"
      style={{
        fill: "#1972b9",
      }}
    />
    <path
      d="M221.81 218.69c5.78.14 11.15.69 16.79 1a9.76 9.76 0 0 0 4-.69 32.89 32.89 0 0 1 15.56-2.62c6.61.55 9-5.5 12.8-10a47.31 47.31 0 0 0 3.86-8.12c1.92-7 11.56-10.87 17.48-7.16 3.44 2.21 7.29 3.72 10.87 5.92-.27 1.93-.27 3.72-1.1 5-4.68 7.71-6.88 15.83-5.5 25 .55 3.31-1.11 7-1.79 10.6v.69a15.13 15.13 0 0 1-5.23 1.38c-5.51-1.1-10.19-2.34-15-3.17-1.79-.41-4.68-.41-5.64.69-3.72 4.41-8.95 5-13.91 6.47-2.75.69-4.95 3-7.57 4.68-1.51 1.1-3 2.62-4.54 2.89-6.47.55-12.8.83-19.27 1.1-9.23-10.46-8.4-21.61-1.79-33.59Z"
      style={{
        fill: "#0f54a0",
      }}
    />
    <path
      d="M358.92 118.75a22.52 22.52 0 0 0-14.32 4c-1.51 1.1-5.37.69-7.43-.41-5.23-2.48-9.78-5.78-14.87-8.67-3.86-2.07-5.23-1.1-5.37 3.44-.41 5.37-.69 10.74-1.1 16s-6.88 11-12.12 11h-14.59a75.48 75.48 0 0 1-4.54-11.56c1.38-5.92 2.75-11 4-16.38 8.4-4.13 17.07-7 26.57-7.16a4.63 4.63 0 0 0 1.93-.28c10.05-6.33 18.86-13.76 23.13-25.47.41-1 .55-2.2 1.1-4 4.81-1.79 9.22-3.16 13.49-4.68a77.51 77.51 0 0 1 6.88 4.68 7.47 7.47 0 0 1 1.38 2.34c3.58 7.85 7 15.7 10.05 23.54-7.17 2.32-12.82 5.76-14.19 13.61Z"
      style={{
        fill: "#1262ae",
      }}
    />
    <path
      d="M166.74 312.17c-1.65 2.34-3.17 4.68-5 7.15-8.54.56-16.94.83-25.2 1.11a7.63 7.63 0 0 1-2.47-.42c-4.82-1.24-8.68-.55-10.19 5.1a4 4 0 0 1-2.07 2.2c.42-5.92 1.1-11.56 1.93-17.62 4.82-5.23 9.09-10.33 9.5-17.76a4.12 4.12 0 0 1 1.38-2.48c5.64-6.74 11.56-13.63 17.34-20.37a1.7 1.7 0 0 1 1.1.14c6.34 3.85 12.25 7.7 18.72 11.83 1.24-3.16 2.34-5.64 3.31-8.12 2.06-5.5 4.13-11 6.61-16.65 2.89-1.38 5.5-2.76 8.12-4 4.54 7 9.08 14.18 13.35 21.89-1.24 1.1-2.06 2.07-3.16 2.48-7 2.75-14.32 5.23-21.2 8.26-2.07.82-4.27 2.75-4.82 4.68-2.71 7.41-4.91 15-7.25 22.58Z"
      style={{
        fill: "#0e54a1",
      }}
    />
    <path
      d="M167.15 312.17a221.94 221.94 0 0 1 6.85-22.58c.55-1.93 2.75-3.86 4.82-4.68 6.88-3 14.17-5.51 21.2-8.26 1.1-.41 1.92-1.38 3.16-2.2 2.2.27 4.41 1.51 5.78.82 5.65-2.34 9.5.42 13.36 3.86 1.51 1.24 3 2.34 4.95 3.71-1.1 9.09-2.48 18.18-3.85 27.81-11 4.82-21.48 10.88-34 12.12-7.58-3.45-14.73-7-22.31-10.6Z"
      style={{
        fill: "#0f519c",
      }}
    />
    <path
      d="M64.87 290.14c3.72-2.62 7.3-5.23 11.15-7.71 4-2.75 5.92-6.19 3.44-11-2.2-4.68-1.1-8.26 4.27-9.64 11.15-2.61 13.08-11.56 14.59-21.47a81.48 81.48 0 0 1 11-1.52 9.58 9.58 0 0 1 4.81 1.24c1.79 1.1 3.17 2.89 5 3.86 5.78 2.89 7.71 7.57 6.61 14.45-4.41 7-6.47 14.73-16 16.38-5.51.83-10.33 5.23-15.28 8.26a7.35 7.35 0 0 0-3.31 4.13c-.55 6.2-.82 12.53-1.23 18.86-.55.28-.83.69-1.38 1-6.2-.68-11.7-1.37-17.35-2.47-2.06-5.1-4.26-9.78-6.33-14.32Z"
      style={{
        fill: "#0f5faa",
      }}
    />
    <path
      d="M90.06 305.83c.28-6.19.55-12.52 1.1-18.72a7.35 7.35 0 0 1 3.31-4.11c5-3 9.77-7.43 15.28-8.26 9.5-1.65 11.56-9.36 16-15.83 8.67 2.89 17.34 6.33 26.15 9.91-5.64 7-11.56 13.91-17.2 20.65a4.12 4.12 0 0 0-1.38 2.48c-.41 7.43-4.68 12.53-9.77 17.76-7-2.2-13.22-4.68-20.38-4-4.3.54-8.7.12-13.11.12Z"
      style={{
        fill: "#105ba6",
      }}
    />
    <path
      fill="#1773ba"
      d="M196.06 95.76c7.57.41 15.15.69 23.13 1.1-1.38 9.09-2.75 17.9-4.27 26.85a5.35 5.35 0 0 1-2.75 3 28.51 28.51 0 0 1-7.3 2.34c-3.85.68-6.05 3-7.84 6.19-.69 1.38-2.21 3.3-3.58 3.44a161.4 161.4 0 0 1-16.38.83 6.31 6.31 0 0 1-4.27-2.07c-3.17-4.26-6.2-8.81-9.91-14.18 8-4.4 15.69-8.53 23.26-12.94 1.38-.82 2.2-2.89 2.89-4.4.83-2.34 1.38-5 2.34-7.71a19.5 19.5 0 0 1 4.68-2.45Z"
    />
    <path
      d="M223.46 252.7c6.61-.69 12.94-1 19.41-1.52 1.51-.27 3-1.79 4.54-2.89 2.62-1.65 4.82-4 7.57-4.68 5-1.51 10.19-2.06 13.91-6.47 1-1.1 3.85-1.1 5.64-.69 4.82.83 9.5 2.07 14.59 3.17-1.79 6.74-4.4 13.49-6.47 20.37-1.1 3.72-3.58 5.23-6.88 4.82-7.85-.83-15.42 2.48-23.4-.55-1.79-.69-5.37 2.89-8.54 4.68-5.64-2.75-11-5.78-16.66-8-4-1.79-5.36-3.86-3.71-8.26Z"
      style={{
        fill: "#0e4f9a",
      }}
    />
    <path
      d="M57.44 196c4.13-1.1 8.4-1.79 12.94-2.62a12.82 12.82 0 0 1 2.62 4.25c2.76 8.4 7.16 14.87 16.94 16.25a4.34 4.34 0 0 1 3 3.3c1.11 6.47 1.66 12.94 2.34 20-8.53.41-16.93.41-25.88.41.14-11.28-10.46-12-17.62-16.79 1.66-8.12 3.58-16.25 5.65-24.78Z"
      style={{
        fill: "#146db6",
      }}
    />
    <path
      d="M189.87 251.87a55.36 55.36 0 0 1-8.54 4.41 58.45 58.45 0 0 1-10.87-1.66c-4.82-1.37-9.36-1.79-13.77.83-3.58-3.86-7-7.85-10.6-11.7-4.13-4.54-4.27-7.3-.41-12.12 3.17-3.85 14-5.5 17.21-1.65 5.37 6.75 13.35 8.26 20.65 10.88s7.7 3.14 6.33 11.01Z"
      style={{
        fill: "#0e5da8",
      }}
    />
    <path
      d="M246.58 72c4.82-.69 9.78-1.11 15-1.52 4 9.91 7.43 19.83 10.46 30.15a12.09 12.09 0 0 1-3.3 1.38c-9.09-3.72-18.17-7.57-27.81-11.57 1.93-6.19 3.86-12.11 5.65-18.44Z"
      style={{
        fill: "#207bc0",
      }}
    />
    <path
      d="M268.75 102.37a10.51 10.51 0 0 1 3.3-1.38c5.51 5 10.74 9.78 16.11 15a135.5 135.5 0 0 1-3.72 16.1c-9.63-2.47-19.13-5.5-29.46-8.81 4.82-7.28 9.23-13.89 13.77-20.91Z"
      style={{
        fill: "#146ab2",
      }}
    />
    <path
      d="M196.06 95.21a23 23 0 0 1-4.82 2.62C184 94 177.07 90 170.32 86.13c-1.65-1-3.44-1.79-5.37-2.9 2.34-2.61 5.1-4.81 7.44-7.57 4.81-5.37 9.63-10.6 17.75-5.37.69.55 2.07.14 3.45.14 1.1 8.26 1.65 16.38 2.47 24.78Z"
      style={{
        fill: "#1e76bd",
      }}
    />
    <path
      d="M267.1 151a109.88 109.88 0 0 1-.69 15c-.83 7.3-8.26 10.46-14.32 6.74a45.31 45.31 0 0 0-8.26-3.44c0-5.09-1.24-10.05 1.38-15.14 2.89-5.64 7.16-8.26 13.21-6.06 2.76 1 5.51 1.79 8.68 2.89Z"
      style={{
        fill: "#0d62ab",
      }}
    />
    <path
      d="M156.55 255.86c4.55-3 9.09-2.61 13.91-1.24a72.78 72.78 0 0 0 10.6 1.79c-1.79 5.51-3.86 11-5.92 16.52-1 2.48-2.07 5-3.31 8.12-6.47-4.13-12.38-8-18.58-11.83a128.72 128.72 0 0 1 3.3-13.36Z"
      style={{
        fill: "#1256a7",
      }}
    />
    <path
      d="M71.2 304.87c5.65.69 11.15 1.38 17.35 2.48 1.51 8 2.61 15.42 3.58 22.85-2.48.83-4.41 1.24-6.61 1.93a15.46 15.46 0 0 1-3.85-.28 9.08 9.08 0 0 0-3.58-.82c-5 .82-9.5 1.37-14 2.2-1.93-5.37-3.72-10.6-5.24-16.52 4.23-4.27 8.36-8.12 12.35-11.84Z"
      style={{
        fill: "#0c5aa5",
      }}
    />
    <path
      d="M81.67 332.13a23.55 23.55 0 0 1 4 .27c4 1.65 7.16 2.89 10.46 4.13l4.41 1.93c-4 9.91-12.81 14.18-21.75 18.86-8.14-5.92-10.79-15.14-14.74-23.82a89.24 89.24 0 0 1 14.31-2.06 24.65 24.65 0 0 0 3.31.69Z"
      style={{
        fill: "#1154a0",
      }}
    />
    <path
      d="M71.2 304.46c-4 4.13-8.12 8-12.39 11.84-2.75-9.78-5.23-19.69-7.43-30 4.27 1 8.4 2.34 13.08 3.85a135.08 135.08 0 0 1 6.74 14.31Z"
      style={{
        fill: "#1655a6",
      }}
    />
    <path
      d="M414.81 179.74q-1.8-9.65-3.44-19.28c-.55-4 0-7.43 3.44-10.05s3.44-6.33 1.92-10.32c-2.61-6.61-5-13.63-7.29-20.79 8 10 17.07 20 23.95 31 5.65 8.94 8.81 19.13 12.8 28.9.69 1.79.56 4 .42 6.34-10.88-1.65-21.34-3.72-31.8-5.78Z"
      style={{
        fill: "#194790",
      }}
    />
    <path
      d="M414.67 180.15c10.6 1.65 21.06 3.72 31.94 5.78a39.78 39.78 0 0 1 4.13 9.22c-3.44-.13-5.37 1-6.89 3.86-2.34 4.4-5.64 8.4-8.39 12.53-5.65-4.69-11.57-9.09-16.66-14.18-4.54-4.36-4.54-10.6-4.13-17.21Z"
      style={{
        fill: "#184787",
      }}
    />
    <path
      d="M373.65 105.12q-5.37-11.7-10.6-23.54a20.75 20.75 0 0 0-1-2.2c.83-.41 2.07-.83 2.62-.41 13.77 11.84 27.53 23.81 41.3 36.2a96.3 96.3 0 0 1-14.32 4.54c-2.75-2.34-5-4.54-7.43-6.47-3.58-2.89-7.16-5.36-10.6-8.12Z"
      style={{
        fill: "#0c5e9c",
      }}
    />
    <path
      fill="#184891"
      d="M435.46 212c2.75-4.54 6.05-8.54 8.39-12.94 1.52-2.89 3.45-4 6.89-3.44 2.48 7.57 4.68 15.28 6.88 23a40.39 40.39 0 0 1 .83 5.09c-.28.55-.42.69-.28.83s.14.27.41.41v1.79c-8.81 1.79-14.45-5.65-21.88-7.71-.69-.28-.69-1.79-1.11-3 0-1.6-.13-2.71-.13-4.03Z"
    />
    <path
      d="M354.51 74.29a99.41 99.41 0 0 1-13.21 4.54c-5.37-2.89-10.19-6.2-15.28-9-4.13-2.2-7.3-4.95-7.85-10.19 5.09 1 10.46 1.66 15.14 3.58 7.3 3.17 14.18 7.16 21.2 11Z"
      style={{
        fill: "#0d5f9d",
      }}
    />
    <path
      fill="#1e4485"
      d="M458.58 224.61c-.27.14-.41 0-.41-.13s0-.28.28-.42.13.14.13.55Z"
    />
    <path
      d="M295.18 237.42c.27-3.45 1.93-7.16 1.38-10.47-1.38-9.22.82-17.34 5.5-25 .83-1.24.83-3 1.65-5 6.89-3 13.08-6.74 20.65-5.78 1.38.14 3.45-1.38 4.41-2.61q6.33-8.4 12.11-16.94c1.52-2.47 3-3.58 5.92-2.47 3.72 1.23 7.71 1.79 11.57 2.89 4.13 1.51 7.57.82 10.6-2.62 1.51-1.79 4-2.34 6-3.44 6.2 3.85 12.39 7.85 19.14 12.11-3.58 4.82-6.88 9.09-10.05 14a5.65 5.65 0 0 1-2.07.28c-8.94.28-9.22-2.06-11.15 8.26-1.51 7.43-6.88 6.47-11.42 7.3a64.08 64.08 0 0 1-14.46 1.1c-4.54-.14-6.33 1.65-7 5.64-.27 2.2-.69 4.13-1.1 6.61a81 81 0 0 1-15.28-1c-7.71-1.66-14.32 2.06-21.06 4.4-1.79.55-2.34 5-3.44 7.71a33.6 33.6 0 0 1-1.93 5Z"
      style={{
        fill: "#11519d",
      }}
    />
    <path
      d="M374.89 165.56c-1.93 1.51-4.41 2.06-5.92 3.85-3 3.44-6.47 4.13-10.6 2.62-3.86-1.1-7.85-1.66-11.57-2.89-2.89-1.11-4.4 0-5.92 2.47q-5.78 8.53-12.11 16.94c-1 1.23-3 2.75-4.41 2.61-7.57-1-13.76 2.75-20.65 5.37-4.13-1.79-8-3.3-11.42-5.51-5.92-3.71-15.56.14-17.48 7.16a39.7 39.7 0 0 1-3.72 7.71c-.28-.41-.14-1-.14-1.38.28-9.22 5.65-14.17 13.63-17.75 1.38-.42 2.34-2.89 2.75-4.68a15.66 15.66 0 0 0 .14-6.2c-.41-4.27 1.79-5.64 5.64-5.64 3.58 0 7.3.13 11 0 4.27 0 7.43-1.52 8.81-6.2 2.2-7.16 3-7.16 10.18-5.5 4.13 1.1 8.4 1.65 12.67 2.89 3.3 1 4.54-.42 5.09-3.17a6.58 6.58 0 0 0 .14-1.65c.28-8.26 3.86-12.67 12.53-14.18 3.16-.55 6.33-4.54 8.12-7.71 2.2-4 4.13-4.41 7.85-2.75a109.51 109.51 0 0 0 12 4.68c2.34 7.43 5 15-2.34 21.33-2.06 1.79-2.89 4.82-4.26 7.58Z"
      style={{
        fill: "#0c58a3",
      }}
    />
    <path
      fill="#105ca8"
      d="M373.1 105.12c4 2.76 7.57 5.23 11.15 8.12 2.47 1.93 4.68 4.13 7.16 6.47a156.55 156.55 0 0 1-8.13 13.77c-3.44-1.79-6.6-3.85-10.18-5.37-4.27-1.79-8.81-3-10.74-8.12-.28-.69-1.79-.69-3-1.24 1-7.85 6.61-11.29 13.77-13.63Z"
    />
    <path
      fill="#0f56a2"
      d="M100.94 338.46c-1.79-.69-3.44-1.24-4.82-1.93-3.3-1.24-6.47-2.48-10.05-4.13 1.65-1 3.58-1.37 6.06-2.2-1-7.43-2.07-14.87-3.17-22.85a1.76 1.76 0 0 1 1-1.38c4.54-.14 8.94.28 13.21-.27 7.16-.69 13.35 1.79 20.1 4.4-.28 5.65-1 11.29-1.65 17.35-6.78 3.99-13.52 7.43-20.68 11.01Z"
    />
    <path
      fill="#0f56a2"
      d="M81.67 331.85a5.48 5.48 0 0 1-2.89-.41 3.75 3.75 0 0 1 2.89.41Z"
    />
  </svg>
);

export default StakeWorld;
